import * as z from 'zod';
import { createContext } from 'react';
import { Issue } from '@/constants';
export const HomeContext = createContext<HomeContextProps>({
	selectedIssue: null,
	setSelectedIssue: () => {},
	setAuthIsOpen: () => {},
	onClickLogOut: () => {},
	setShowLogout: () => {},
	isAuthenticated: false,
});

export const modeTypeSchema = z.enum([
	'top-stories',
	'magazines',
	// Retired section, kept parseable so old `?section=library` links
	// still validate (`useMode` maps it to magazines).
	'library',
	'contest',
	'daily-news',
]);

export type ModeType = z.infer<typeof modeTypeSchema>;

interface HomeContextProps {
	mode?: ModeType;
	isAuthenticated: boolean;
	selectedIssue: Issue | null;
	setSelectedIssue: (issue: Issue | null) => void;
	setAuthIsOpen: (isAuthOpen: boolean) => void;
	setShowLogout: (value: boolean) => void;
	onClickLogOut: () => void;
	toggleAppMenu?: () => void;
}
